import { ReactElement } from 'react';

export interface ListViewZeroStateProps {
  message?: string;
  Button: ReactElement;
}

const DEFAULT_MSG =
  'Get the most out of your workspace \n Go ahead and hit create to get things started.';

function ListViewZeroState({
  message = DEFAULT_MSG,
  Button,
}: ListViewZeroStateProps) {
  // Split the message by newline characters and join with <br /> tags
  const formattedMessage = message.split('\n').map((line, i) => (
    <span key={i}>
      {line}
      {i < message.split('\n').length - 1 && <br />}
    </span>
  ));

  return (
    <div className="center-container">
      <div className="list-view-zero-state-message">{formattedMessage}</div>
      <div className="list-view-zero-state-button">{Button}</div>
    </div>
  );
}

export default ListViewZeroState;
